<template>
    <div class="container">
        <!-- <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <h3>Importar Bitácora</h3>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-card-title class="titulopagina">IMPORTAR BITACORA</v-card-title>
        <v-row>
            <v-tabs
            background-color="blue accent-3"
            class="elevation-2"
            dark
            :centered="true"
            :grow="true"
            :vertical="false"
            :right="false"
            prev-icon="mdi-arrow-left-bold-box-outline"
            next-icon="mdi-arrow-right-bold-box-outline"
            :icons-and-text="true"
            >
            <v-tabs-slider></v-tabs-slider>

            <!-- tab generar formato -->
            <v-tab
                :href="`#tab-generar-excel`"
            >
                Generar Formato
                <v-icon>get_app</v-icon>
            </v-tab>

            <v-tab-item
                :value="'tab-generar-excel'"
            >
                <v-card
                flat
                tile
                >
                <v-card-text>Generar Formato Excel</v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-select
                            outlined
                            v-model="select_generar_formato"
                            :items="puntos_medicion"
                            item-text="nombre_punto"
                            item-value="id"
                            label="Seleccione Punto de Medición"
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-btn color="blue" dark @click="generarFormato"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    
                </v-card-text>
                </v-card>
            </v-tab-item>
            <!-- tab generar formato -->

            <!-- tab importar Excel -->
            <v-tab
                :href="`#tab-importar-excel`"
            >
                Importar Datos
                <v-icon>publish</v-icon>
            </v-tab>

            <v-tab-item
                :value="'tab-importar-excel'"
            >
                <v-card
                flat
                tile
                >
                <v-card-text>Importar Excel</v-card-text>
                <v-card-text>
                    <alert></alert>
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-select
                            outlined
                            v-model="select_importar_formato"
                            :items="puntos_medicion"
                            item-text="nombre_punto"
                            item-value="id"
                            label="Seleccione Punto de Medición"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input
                            id="input_archivo"
                            @change="cambioArchivo"
                            v-model="archivo" 
                            label="Agregue Excel" 
                            accept=".xlsx, .xls"
                            outlined 
                            dense>
                            </v-file-input>
                        </v-col>
                        <v-col>
                            <v-btn color="green darken-1"  :dark="!desactivar_importar" :disabled="desactivar_importar" @click="importarDatos"><v-icon>publish</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                </v-card>
            </v-tab-item>
            <!-- tab importar Excel -->

    </v-tabs>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Alert from '@/components/shared/Alert.vue';
export default {
    data:()=>({
        puntos_medicion:[],
        fecha_inicio:'',
        fecha_fin:'',
        select_generar_formato:'',
        select_importar_formato:'',
        archivo:{},
        formatos_aceptados:['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/wps-office.xlsx']
    }),
    mounted() {
        this.cargarPuntosMedicion();
    },
    methods: {
        async cargarPuntosMedicion(){
            //this.mostrarLoading('Cargando Puntos de Medición...');
            this.mostrarLoading({titulo:'Cargando Puntos de Medición...',color:'green'})

            let url = `${this.base_url}punto_medicion`;
            // console.log('headers',this.headers.headers);
            this.axios.get(url,this.headers).then((res)=>{
                this.puntos_medicion = res.data.data;
                console.log('puntos_medicion',this.puntos_medicion);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        cambioArchivo(){
            console.log('archivo',this.archivo);
            // busca entre los formatos aceptados
            var aceptado = this.formatos_aceptados.find(formato => {
                return formato === this.archivo.type;
            });
            
            if(aceptado == undefined){
                /**solo se acepta archivos excel */
                this.archivo = {};
            }
            console.log('aceptado',aceptado);
        },

        async generarFormato(){
            console.log('punto medicion',this.select_generar_formato);
            let url = `${this.base_url}resultados/formato_bitacora/${this.select_generar_formato}`;
            this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta formato',res);
                window.location.href = res.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
        },

        async importarDatos(){
            //this.mostrarLoading('Subiendo Archivo...');
            this.mostrarLoading({titulo:'Subiendo Archivo...',color:'green'})

            //subiendo el archivo
            let token = this.headers.headers['Authorization'];
            let cabecera = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }
            // cabecera['headers']['Content-Type']='multipart/form-data';
            let body = new FormData();
            body.append('archivo', this.archivo);
            let url = `${this.base_url}resultados/subir_archivo`;
            console.log('headers',cabecera);
            await this.axios.post(url, body, cabecera).then((res) =>{
                this.enviarNombreArchivo(res);
            }).catch((error) =>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async enviarNombreArchivo(res){
            console.log('cabecerita',this.headers);
            console.log('res archivo',res);
            //this.mostrarLoading('Procesando Datos...');
            this.mostrarLoading({titulo:'Procesando Datos...',color:'green'})

            let url = `${this.base_url}resultados/importar_bitacora/${this.select_importar_formato}`;
            let body = {
                nombre_archivo:res.data.nombre
            }
            let conf = {};
            //enviando nombre de archivo
            await this.axios.post(url,body,this.headers).then((res)=>{
                console.log('archivo importado',res.data.message);
                conf.tipo = "success";
                conf.mensaje = res.data.message;
                Event.$emit('mostrar_alert',conf);
                this.limpiar();
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                conf.tipo = "error";
                conf.mensaje = `No se Ha podido importar el archivo`;
                Event.$emit('mostrar_alert',conf);
                this.ocultarLoading();
            });
        },
        limpiar(){
            this.select_importar_formato='',
            this.archivo = {};
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        desactivar_importar(){
            if(this.archivo != {} && this.select_importar_formato != ''){
                var aceptado = this.formatos_aceptados.find(formato => {
                return formato === this.archivo.type;
                });
                if(aceptado == undefined){
                    return true;
                }else{
                    return false;
                }
            }

            return true;
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert
    }
}
</script>